import React, {FC, useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, notification, Row} from "antd";
import {useTranslation} from "react-i18next";
import {getIcerini, ISaveIceriniRequest, saveIcerini} from "../../../services/eticket/icerini";

interface IProps {
  terminalId: string;
}

export const TerminalPrmETIcerini: FC<IProps> = ({terminalId}) => {
  const {t} = useTranslation()
  const [form] = Form.useForm()
  const [formValues, setFormValues] = useState<ISaveIceriniRequest>();
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  useEffect(function () {
    if (terminalId !== "") {
      getIcerini({terminalId: terminalId}).then(res => {
        if (res.status === 0) {
          setFormValues(res.data)
          form.setFieldsValue(res.data)
        }
      })
    }
  }, [terminalId])
  const saveForm = (values) => {
    if (formValues === undefined) {
      return
    }
    setBtnLoading(true)
    saveIcerini({terminalId: terminalId, icerini: values["icerini"]}).then(res => {
      if (res.status === 0) {
        notification.success({
          message: "save success"
        })
      }
    }).finally(() => {
      setBtnLoading(false)
    })
  }
  return (
    <Row gutter={10} style={{marginTop: "20px"}} hidden={terminalId === ""}>
      <div className='form-content-container-content'>
        <Form layout='vertical' form={form} initialValues={formValues} onFinish={saveForm}>
          <Row gutter={30}>
            <Col flex="300px">
              <Form.Item label={t('form.ECC_IP')} name={["icerini", "TransXML", "ECC_IP"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.ECC_Port')} name={["icerini", "TransXML", "ECC_Port"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.ICER_IP')} name={["icerini", "TransXML", "ICER_IP"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.ICER_Port')} name={["icerini", "TransXML", "ICER_Port"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.CMAS_IP')} name={["icerini", "TransXML", "CMAS_IP"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.CMAS_Port')} name={["icerini", "TransXML", "CMAS_Port"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.TMLocationID')} name={["icerini", "TransXML", "TMLocationID"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.MerchantID')} name={["icerini", "TransXML", "MerchantID"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.Slot')} name={["icerini", "TransXML", "Slot"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.ReaderUartDebug')} name={["icerini", "TransXML", "ReaderUartDebug"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.MaxALAmt')} name={["icerini", "TransXML", "MaxALAmt"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.BLCName')} name={["icerini", "TransXML", "BLCName"]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t('form.ICERKey')} name={["icerini", "TransXML", "ICERKey"]}>
                <Input/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider/>
        <div>
          <Button type="primary" shape="round" style={{width: "200px", float: "right"}}
                  htmlType="submit" loading={btnLoading} onClick={() => form.submit()}>
            {t('button.save')}
          </Button>
        </div>
      </div>
    </Row>
  )
}